module.exports = __webpack_public_path__ + "img/check-circle-small-green.308b5a0f.svg";